import { iconA11y, type IconProps } from './iconProps';

/**
 * Figma Graph Stat corner arrow (`Vector 138`, node `755:80041` / `755:80048`).
 * Authored as ↗; CSS rotate (−45° up, 45° + flip-Y down) matches the design.
 */
const TREND_ARROW_PATH =
  'M4.28329 0H18.759V14.4757H15.8523V4.96218L2.0554 18.759L0 16.7036L13.7969 2.90678H4.28329V0Z';

const TREND_ARROW_VIEWBOX = 18.759;

type TrendArrowDirection = 'up' | 'down';

type TrendArrowIconProps = IconProps & {
  direction: TrendArrowDirection;
};

export function TrendArrowIcon({
  direction,
  size = 19,
  title,
  className,
}: TrendArrowIconProps) {
  const transform =
    direction === 'up' ? 'rotate(-45deg)' : 'rotate(45deg) scaleY(-1)';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 ${TREND_ARROW_VIEWBOX} ${TREND_ARROW_VIEWBOX}`}
      fill="none"
      className={className}
      style={{ transform }}
      {...iconA11y(title)}
    >
      {title ? <title>{title}</title> : null}
      <path d={TREND_ARROW_PATH} fill="currentColor" fillRule="evenodd" clipRule="evenodd" />
    </svg>
  );
}
